document.addEventListener "ready", (event) ->
  if typeof gtag is 'function'
    gtag('js', new Date())
    gtag('set', 'location', event.data.url)
    gtag('send', 'pageview')
